<script lang="ts" setup>
import KaSkeletonBase from './KaSkeletonBase.vue';
import { useSkeletonA11yCheck } from './useSkeletonA11yCheck';

const props = defineProps<{ decorative?: boolean }>();

if (!props.decorative) {
  useSkeletonA11yCheck('KaSkeletonCheckbox');
}
</script>
<template>
  <KaSkeletonBase
    data-testid="skeletonCheckbox"
    aria-hidden="true"
    class="h-4 w-4 rounded bg-gray-200"
  />
</template>
